import React from 'react';

import { CentroPedidoListComp, CentroPedidosFormComp } from './components';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function CentroPedidoList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPLEMENTAR_CENTRO_PEDIDO_GERENCIAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <CentroPedidoListComp />
        </ListagemProvider>
    );
}

export function CentroPedidoForm() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPLEMENTAR_CENTRO_PEDIDO_GERENCIAR'])) return alertNotPermission();

    return (
        <FormProvider>
            <CentroPedidosFormComp />
        </FormProvider>
    );
}
